// extracted by mini-css-extract-plugin
module.exports = {"popover":"SearchTipPopover_popover__j6hJC"};